import axios from 'axios';
import { useQuery } from 'react-query';

import getBaseApi from '@luna-protocol/core/src/utils/getBaseApi';
import { EMAIL_RELATED_DEALERS } from './constants';

export interface EmailRelatedDealer {
  user_id: string;
  email: string;
  entity_id: string;
  first_name: string;
  last_name: string;
  user_type: string;
  dealer_name: string;
}

const useGetEmailRelatedDealers = (enabled: boolean) => {
  return useQuery<EmailRelatedDealer[]>(
    [EMAIL_RELATED_DEALERS],
    async () => {
      const resp = await axios.get(`${getBaseApi()}/dealer/users/email_related`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('user_token')}`,
        },
      });
      return resp.data.users as EmailRelatedDealer[];
    },
    { enabled },
  );
};

export { useGetEmailRelatedDealers };
